<template>
  <div class="email-notification-table-wrapper">
    <VDataTable
      :headers="tableFields.headers"
      :rows="tableFields.rows"
      extraClass="account-settings-emails-table"
    ></VDataTable>

    <VElementsAddingModal
      :isOpen="!!currentPeriod"
      :elements="emails"
      @save="emails => saveSettings(currentPeriod, emails)"
      @close="currentPeriod = null"
    ></VElementsAddingModal>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import { mapActions } from "vuex";
import withForm from "@/mixins/withForm";
import withToasted from "@/mixins/withToasted";

import VDataTable from "@/components/VDataTable";
import VElementsAddingModal from "@/components/VElementsAddingModal";
import VSwitcher from "@/components/VSwitcher";

export default Vue.component("AccountSettingsEmailNotificationsTable", {
  props: {
    daily_reports: VueTypes.bool,
    monthly_reports: VueTypes.bool,
    daily_emails: VueTypes.array,
    monthly_emails: VueTypes.array
  },

  component: {
    VDataTable,
    VElementsAddingModal
  },

  data() {
    return {
      currentPeriod: null,
      emails: [],
    };
  },

  mixins: [withToasted, withForm],

  methods: {
    onMailClick(emailsArr, currentPeriod) {
      this.emails = emailsArr;
      this.currentPeriod = currentPeriod;
    },

    saveSettings(currentPeriod, values) {
      const periodKey =
        currentPeriod === "daily_emails"
          ? "daily_notification_emails"
          : "monthly_notification_emails";
      this.updateUser({
        values: { [periodKey]: [...values].join(",") },
        onSuccess: () => this.toast("Settings have been saved!", "success", {
          icon: "check "
        }),
        onError: () => this.toast("Something went wrong!", "error", {
          icon: "times"
        })
      });
    },

    ...mapActions("account", ["updateUser"])
  },

  computed: {
    tableFields() {
      return {
        headers: [
          {
            key: "name",
            label: "Name",
            extraClass: "name",
            width: "35%"
          },
          {
            key: "type",
            label: "Type",
            width: "15%"
          },
          {
            key: "created_at",
            label: "  Recipients",
            width: "40%"
          },
          {
            key: "off_on",
            label: "Off/On",
            width: "10%"
          }
        ],
        rows: [
          {
            extraClass: `${this.daily_reports === false ? "row-disabled" : ""}`,
            values: [
              {
                key: "name",
                value: "Daily summary of sent mail",
                extraClass: "name"
              },
              {
                key: "type",
                value: "Notification",
                extraClass: "type"
              },
              {
                key: "recipients",
                value: this.daily_emails.join(", "),
                extraClass: "recipients",
                click: () => {
                  this.onMailClick(this.daily_emails, "daily_emails");
                }
              },
              {
                key: "daily_reports",
                label: "",
                component: VSwitcher,
                display: true,
                props: {
                  type: "toggleReverse",
                  activeKey: this.daily_reports,
                  switcherKeys: {
                    left: {
                      key: false,
                      label: ""
                    },

                    right: {
                      key: true,
                      label: ""
                    }
                  },
                  onClickHandler: activeKey => {
                    this.updateUser({
                      values: { daily_reports: activeKey }
                    });
                  }
                }
              }
            ]
          },

          {
            extraClass: `${
              this.monthly_reports === false ? "row-disabled" : ""
            }`,
            values: [
              {
                key: "name",
                value: "Monthly summary of sent mail",
                extraClass: "name"
              },
              {
                key: "type",
                value: "Notification",
                extraClass: "type"
              },
              {
                key: "recipients",
                value: this.monthly_emails.join(", "),
                extraClass: "recipients",
                click: () => {
                  this.onMailClick(this.monthly_emails, "monthly_emails");
                }
              },
              {
                key: "monthly_reports",
                label: "",
                component: VSwitcher,
                display: true,
                props: {
                  type: "toggleReverse",
                  activeKey: this.monthly_reports,
                  switcherKeys: {
                    left: {
                      key: false,
                      label: ""
                    },

                    right: {
                      key: true,
                      label: ""
                    }
                  },
                  onClickHandler: activeKey => {
                    this.updateUser({
                      values: { monthly_reports: activeKey }
                    });
                  }
                }
              }
            ]
          }
        ]
      };
    }
  }
});
</script>

<style lang="scss" scoped>
.email-notification-table-wrapper {
  /deep/ {
    table.account-settings-emails-table {
      table-layout: fixed;
    }

    tbody,
    thead {
      th,
      td {
        padding-right: 30px;
      }

      td {
        word-break: break-word;
      }
    }

    tbody tr {
      &:hover {
        background: none;
      }

      td.recipients {
        font-family: "Lato-Light", sans-serif;
        text-overflow: ellipsis;
        padding-right: 20px;

        span {
          display: inline-block;
          max-width: 100%;
          @include textCropEllipsis();
        }

        &:hover {
          color: $primary-color;
        }
      }
    }

    table.account-settings-emails-table {
      tr.row-disabled {
        td {
          opacity: 0.5;
          pointer-events: none;
        }

        td:last-child {
          pointer-events: auto;
        }
      }
    }
  }
}
</style>
